export default __webpack_public_path__ + "assets/images/account-background.png?8e33d4a8";